import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sexy animated spirographs in 35 sloc of d3.js",
  "description": "",
  "published": "2013-03-07T00:00:00.000Z",
  "redirect_from": ["/blog/sexy-animated-spirographs-in-35-sloc-of-d3-js/swizec/6052"],
  "categories": "Animation, d3.js, JavaScript, Spirograph, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You probably remember spirographs as kid's toys from your youth. I had a simple set that was just a collection of plastic sprockets with holes for pencils.`}</p>
    <p>{`Endless amounts of fun when I was two or three years old. I think ... I don't really remember much from that time, but I remember having those thingies and loving playing with them. One of my earliest memories even!`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "800px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/44873831f6014765fd2854be4575ff12/4b190/Spirographhfie73.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2023l1%2023%203-2%208-6%208-7c0-1%202-3%204-3l2-2c-1-1%202-2%2028-3%2032-1%2042-2%2043-3l3%204c2%205%203%207%201%207l-2%204-2%205h-8c0-1-1-2-2-1l-2-1c1-1%200-1-1-1l-4%207a2301%202301%200%2001-43%2095c-2%200-1%202%201%202v1c-3%200-7%207-6%209%201%201%200%201-1%201v2l-1%202-1%202-1%201-1%201-2%206-2%205-2%202-4%207a4999%204999%200%2001-9%2020c-1%204-4%205-5%203-3-4-3%203-3%2048v49h401v-50c0-27%200-49-1-48%200%201-1%202-3%202l-2%201h5v53h-3l-13%201h-7c-1%200-2%200-2%202l-1-1c-1-2-1-2-2%201%200%203%200%203-5%203-4%200-5%200-6-3l-1-2v2c1%203%201%203-5%203-4%200-5%200-6-2l-1-3v2c0%203%200%203-5%203s-6-1-6-2l1-1%201-2h-1c-1%202-2%202-2%201v1c0%203%200%203-6%203h-6v-3c0-2%200-3-1-2l-1%203c1%202%201%202-5%202-5%200-6-1-6-3l-1-3v3c0%202-1%203-6%203h-5v-6l-1%203c-1%203-1%203-6%203-5-1-6-1-6-4l-1-3v3l-1%203c-5%201-5%201-5-3l1-4v3c0%203%200%203%201%202l1-1c0%201%200%202%201%201v-6c0-6%200-7%202-9l3-5%201-1%204-4%203-4%202-3c1-1%201-2%202-1l2-2%201-2%201-2%201-2%204-9%202-1%201-2%2010-1c10%200%2016-1%2032-4a169%20169%200%200120-3l23-4%203-1c0-1-5-2-23-2l-30-1-6-1%205-1a318%20318%200%200121-4l-26%203c-8%202-26-1-26-4%200-2%2023-3%2041-1a195159%20195159%200%200037%202c-7%200-6-2%202-2l5-1h-4a493%20493%200%2001-80-5v-25h15l26-1a160%20160%200%200143%203c0-1-6-3-14-4h-7l8-2c7-1%209-1%2011%201%202%201%202%201%202-2l-2-2-6-2-13-2-9-2h8c5%200%207%200%206-1l6-1c11-1%2012-2%201-1h-25l-6-1%206%201c7%202%205%203-9%204l-18%202c-12%202-33-1-26-3v-1l-2-1-1-2-2-3c-6-10-28-27-35-27l-1-1c0-2-13-4-20-3l-20%202c-23%200-33%203-50%2012-8%204-9%204-6%201l4-2v-1h-3l-2-1c0-2-1-2-3%200l-2%201-4%202-2%202-5-11a1721%201721%200%2001-38-85%202339%202339%200%2001167-2%201202%201202%200%2000-55%202c54%200%2063%200%2063%202l-6%201c-8%200-5%201%207%203l7-1h1c1%201%203%202%2011%202%2055%201%2058%201%2060%204l4%203%204%202h-3c-6-2%200%202%209%205l8%203-3%201-3%201h4c5%200%205%200%205-26V0h-81a481%20481%200%2000-94%205c1%201%201%201-2%201l-3-1-3-1c-2%200-2%200%200%201%203%201-3%203-8%203-3-1-4-1-6%201-3%204-6%204-8%201-2-2-3-3-6-3-2%200-3%200-2-1l5-1c7%200%2012-1%2014-4%201-1-4-1-45-1-46%200-47%200-48%202%200%203-2%203-2%200-1-2-2-2-13-2L88%201c0%201-10%205-26%209l-16%204c-10%204-11%204-12-1-2-4-1-7%203-10%205-3%204-3-9-3-11%200-12%200-13%203l-3%202%201-2%201-3H0v23m108%2044a69723%2069723%200%2000-64%20189l7%201a109049%20109049%200%2000106%204c4%200%205%200%205-3v-2l-1%202h-1l-1-2v2l-1%202v-2c0-2%200-2-1-1h-2c-1-1-1-1-1%201h-1l2-6c3-4%202-10-1-14-4-4-8-7-11-7l-2-1c0-1%201-2%205-1h5l-2-3c-1-3-2-3-4-3l-8%201-5%201%206-2c7-2%209-3%207-4l-1-1c0-3-6-8-9-7-2%200-2%200-1-1%202-2%202-2%201-3-2-2%200-2%202-1%201%202%202%202%206%200l2-2-1-1c1-2-2-11-3-11l-1-1c1-1%200-5-1-10-2-13-1-26%203-35l3-7%201-1%203-5%202-4a548%20548%200%2000-37-71c1-8-1-4-6%209m225-11l-21%204c-6%200-3%202%204%202%2010%202%2011%202%205%204s-7%203-2%203l5%201-2-1c-2%200%200-2%204-3h21c16%200%2016%200%2019%203%206%205%203%206-14%206l-10%201c4%201%200%202-6%202l-13%201h40c-3%200-2-2%203-2%204-1%207%200%207%203h-4c-3%200-3%200%201%202%204%201%207%204%205%206-1%202-19%202-31%200l-39-1h-30c0%202%202%202%207%203a536%20536%200%200119-1h37c12%201%2013%202%204%203l-7%202-13%204-4%201-4%201-4%202c-1%202-13%205-16%205-6%200-7-2-7-7%200-6-2-6-2%200-1%205%201%208%207%209%204%200%2015-1%2013-2-4-1%2010-5%2014-4l8%201h3l6%203%2014%204h23l8-4c5-3%206-4%2012-4%208%201%209-1%203-2l-4-1c-1-1%206-9%207-8V68c-2-2-9-4-18-4l-9-1-4-2-3-1c0-2-30-5-32-4m3%202l-18%203c-1%202%2012%202%2016%201%205-3%2017-3%2024%200l8%202c2%200%201-1-2-2-9-4-20-5-28-4m42%2016c-4%201-4%202-3%204%200%203%201%203%206%205s5%202%2010%200%205-3-3-8c-4-2-5-2-10-1m16%2010l-3%203c1%201%200%201-2%201h-6l-4%201-1%204%201%203%204%202c5%201%206%201%209-3s3-5%201-6c-1-1-1-1%201-1%202%201%203%201%203-1l2-3h-5m-26%207l-4%201%203%201h-2c-8-1-19%200-26%202l-14%204-6%202c0%201%205%202%206%201l6-1c3%200%205%200%204%201a3086%203086%200%200127%208c6%200%206%200%2010-3l3-5-20-1c-18-1-18-1-8-1a139%20139%200%200128%200c2-1%201-3-3-4-5-1-5-2%200-2h4c1-1%200-4-1-4l-7%201m-153%2037c-2%201-3%202-3%205v3l-2-3c-3-2-3-2-5-1l-4%201c-3%201-4%203-2%203%203%200%203%202%201%202l-11%202%202%201h4c2-1%205-1%207%201h1c0-2%202-3%203-1l2%201h3c0-2%202-1%202%201h6c1%200%202%200%202%202h3l1%202c2%200%205%201%208%204l2%201%201%201%201%202%203%203%201%203%202%205c2%207%200%2021-2%2024l-2%202c1%201-9%2011-11%2011l-1%201c-1%202-9%205-16%207-4%201-10%200-17-2-2%200-2%200-1%201%202%202%2017%205%2029%205%2019%200%2043-7%2051-15l2-1%2010-9c1-3%201-3-1-6-2-1-4-4-4-6l-4-8c-3-4-4-8-2-7l2-1c0-2%201-2%201-1l-1%203v2l1%203c0%202%204%207%206%207l1%201-1%201c-3-1-2%200%201%204%203%203%203%203%204%202%200-2%200-3-2-4v-17l-1-4c0-4-1-4-4-1-4%203-5%202-1-1l4-3%201-1-1-2c-2%200-11%209-11%2011l-1%201c-2-2-1-15%201-18s2-6%200-6l-1-1c1-2%200-2-2-2l-6-2c-2-2-4-3-12-5-7-1-34-2-37-1m142%2015a617%20617%200%2001-22%202c3%203%2035%205%2050%203%2016-2-11-7-28-5m-39%204c-4%200-4%204-1%204h42l-13-3c-12-2-21-2-28-1m-227%208l-16%2048c-3%2011-4%2016-1%2014l1-3%201-9a667%20667%200%200015-50m234%2038l-7%202h16l24%202c6%201%2010%202%2017%201%2011-1%2011-2%200-2l-23-2c-17-2-18-2-27-1m-10%204v4c1%201%201%201-1%201-1%201-1%201%202%202%205%202%2037%200%2046-4%203-1-14-3-30-4l-17%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/44873831f6014765fd2854be4575ff12/ca0a1/Spirographhfie73.webp 223w", "/static/44873831f6014765fd2854be4575ff12/75680/Spirographhfie73.webp 445w", "/static/44873831f6014765fd2854be4575ff12/d00b9/Spirographhfie73.webp 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/44873831f6014765fd2854be4575ff12/853b2/Spirographhfie73.jpg 223w", "/static/44873831f6014765fd2854be4575ff12/0a4fe/Spirographhfie73.jpg 445w", "/static/44873831f6014765fd2854be4575ff12/4b190/Spirographhfie73.jpg 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/44873831f6014765fd2854be4575ff12/4b190/Spirographhfie73.jpg",
                "alt": "Spirograph",
                "title": "Spirograph",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Spirograph`}</figcaption>{`
  `}</figure><img parentName="p" {...{
        "src": "",
        "alt": null
      }}></img></p>
    <p>{`Last night I was making an animation example for the d3.js book I'm writing and ended up with the idea of progressively drawing out cool looking parametric equations. Little did I know, those are actually spirographs! Learned something while I was learning something.`}</p>
    <p>{`<`}{`tweet gone missing>`}</p>
    <p>{`My failure in common knowledge aside, it's possible to animate the drawing of parametric equations with just a few lines of `}<a parentName="p" {...{
        "href": "http://d3js.org"
      }}>{`d3.js`}</a>{` code. What I'm about to show you has a pretty big problem, but produces cool looking results "in the lab". Try to guess what the problem is.`}</p>
    <h2 {...{
      "id": "animating-spirographs"
    }}>{`Animating spirographs`}</h2>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/03/0007_04_04.png",
        "alt": "After a few steps",
        "title": "After a few steps"
      }}></img></p>
    <p>{`We'll make an animation timer and for each tick we'll draw a new step of the spirograph. After the spirograph is finished, we'll stop the timer. To make the animation more interesting to watch, we'll also fake a brush flying around (just a black dot).`}</p>
    <p>{`We start with some basic html:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<title></title>
<link href="../bootstrap/css/bootstrap.min.css" rel="stylesheet" />

<div id="graph"></div>

<script src="http://d3js.org/d3.v3.min.js"></script>
<script src="timers.js"></script>
`}</code></pre>
    <p>{`Then we hop into the javascript to flesh out the actual code.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var width = 600,
  height = 600,
  svg = d3
    .select("#graph")
    .append("svg")
    .attr({ width: width, height: height });
`}</code></pre>
    <p>{`I found the parametric function in the wikipedia's article on parametric equations. We'll be giving it a simple parameter calculated from the animation timer and it will return a two dimensional position.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var position = function (t) {
  var a = 80,
    b = 1,
    c = 1,
    d = 80;

  return {
    x: Math.cos(a * t) - Math.pow(Math.cos(b * t), 3),
    y: Math.sin(c * t) - Math.pow(Math.sin(d * t), 3),
  };
};
`}</code></pre>
    <p>{`Tweaking the `}<em parentName="p">{`a`}</em>{`, `}<em parentName="p">{`b`}</em>{`, c, and `}<em parentName="p">{`d`}</em>{` parameters will change the final shape.`}</p>
    <p>{`Next we're going to define some scales to help us translate between maths space and our drawing space.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var t_scale = d3.scale
    .linear()
    .domain([500, 30000])
    .range([0, 2 * Math.PI]),
  x = d3.scale
    .linear()
    .domain([-2, 2])
    .range([100, width - 100]),
  y = d3.scale
    .linear()
    .domain([-2, 2])
    .range([height - 100, 100]);

var brush = svg.append("circle").attr({ r: 4 }),
  previous = position(0);
`}</code></pre>
    <p>{`The `}<em parentName="p">{`t_scale`}</em>{` is going to translate time into a parameter, `}<em parentName="p">{`x`}</em>{` and `}<em parentName="p">{`y`}</em>{` calculate proper positions on the final image using the coordinates returned by the position function.`}</p>
    <p>{`We also put a simple circle on the image - this will represent the brush - and we need to take note of the previous position so we can draw lines between our current and previous state.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var step = function (time) {
  if (time > t_scale.domain()[1]) {
    return true;
  }

  var t = t_scale(time),
    pos = position(t);

  brush.attr({ cx: x(pos.x), cy: y(pos.y) });
  svg.append("line").attr({
    x1: x(previous.x),
    y1: y(previous.y),
    x2: x(pos.x),
    y2: y(pos.y),
    stroke: "steelblue",
    "stroke-width": 1.3,
  });

  previous = pos;
};
`}</code></pre>
    <p>{`This is our `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Step_function",
        "title": "Step function"
      }}>{`step function`}</a>{`. It draws every consecutive step of the animation by moving the brush and putting a line between the current and previous position. The animation will stop when this function returns `}<em parentName="p">{`true`}</em>{` so we make sure the `}<em parentName="p">{`time`}</em>{` parameter doesn't go beyond `}<em parentName="p">{`t_scales`}</em>{`'s domain.`}</p>
    <p>{`Finally, we simply start the timer.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var timer = d3.timer(step, 500);
`}</code></pre>
    <p>{`The timer will start running after 500 milliseconds and repeatedly call the `}<em parentName="p">{`step `}{`_`}{`function until it returns `}{`_`}{`true.`}</em></p>
    <p>{`You can check the animation out via `}<a parentName="p" {...{
        "href": "http://swizec.github.com/d3.js-book-examples/ch4/timers.html"
      }}>{`the magic of github pages`}</a>{`. The final spirograph looks like this:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/03/0007_04_05.png",
        "alt": "A parametric equation visualised",
        "title": "A parametric equation visualised"
      }}></img></p>
    <p>{`Figured out the problem yet?`}</p>
    <p>{`The problem with this approach is that I'm using the animation timer itself as a parameter to the function, which means point density depends on how long you're willing to let the animation run. It will always draw the complete function because of how d3 scales work, but it might look `}<em parentName="p">{`very`}</em>{` approximate. Think squares for circles approximate.`}</p>
    <p>{`Another problem is that using a slower computer, or doing anything that lags the CPU even a little bit while the animation is running will ruin the final picture.`}</p>
    <p>{`For instance, this is what happens when I switch desktops around while the browser is drawing.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/03/glitchy-spirograph.png",
        "alt": "Glitchy spirograph",
        "title": "Glitchy spirograph"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.universetoday.com/100325/the-vela-pulsar-as-a-spirograph/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/148486923_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.universetoday.com/100325/the-vela-pulsar-as-a-spirograph/"
        }}>{`The Vela Pulsar as a Spirograph`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://hackaday.com/2013/02/21/laser-spirograph/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/147121686_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://hackaday.com/2013/02/21/laser-spirograph/"
        }}>{`Laser Spirograph`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.gizmodo.co.uk/2013/02/watch-the-universe-draw-an-awesome-spirograph-in-the-sky/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/148806266_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.gizmodo.co.uk/2013/02/watch-the-universe-draw-an-awesome-spirograph-in-the-sky/"
        }}>{`Watch the Universe Draw an Awesome Spirograph in the Sky`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://phys.org/news/2013-02-fermi-motion-spirograph.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/148576796_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://phys.org/news/2013-02-fermi-motion-spirograph.html"
        }}>{`Fermi's motion produces a study in spirograph`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=fb22a411-7098-4367-b54c-e6363f006ad9",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      